import React, { useEffect, useState, useRef } from "react";
import { auth, db } from "../config";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";

function Header() {
  const [user, setUser] = useState(null);
  const [balance, setBalance] = useState(null);
  const logoutTimerRef = useRef(null);

  // Duration in ms (1 minute)
  const INACTIVITY_LIMIT =5 * 60 * 1000;

  const handleLogout = async () => {
    try {
      clearTimeout(logoutTimerRef.current);
      await signOut(auth);
      window.location.href = "/";
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const resetTimer = () => {
    clearTimeout(logoutTimerRef.current);
    logoutTimerRef.current = setTimeout(() => {
      // alert("You've been logged out due to inactivity.");
      handleLogout();
    }, INACTIVITY_LIMIT);
  };

  const setupInactivityTracking = () => {
    window.addEventListener("mousemove", resetTimer);
    window.addEventListener("keydown", resetTimer);
    window.addEventListener("mousedown", resetTimer);
    window.addEventListener("touchstart", resetTimer);
    window.addEventListener("scroll", resetTimer);
    resetTimer();
  };

  const removeInactivityTracking = () => {
    window.removeEventListener("mousemove", resetTimer);
    window.removeEventListener("keydown", resetTimer);
    window.removeEventListener("mousedown", resetTimer);
    window.removeEventListener("touchstart", resetTimer);
    window.removeEventListener("scroll", resetTimer);
    clearTimeout(logoutTimerRef.current);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      setUser(currentUser);

      if (currentUser) {
        const userRef = doc(db, "users", currentUser.uid);
        const userSnap = await getDoc(userRef);
        setBalance(userSnap.exists() ? userSnap.data().balance || 0 : 0);
        setupInactivityTracking();
      } else {
        setBalance(null);
        removeInactivityTracking();
      }
    });

    return () => {
      unsubscribe();
      removeInactivityTracking();
    };
  }, []);

  return (
    <header className="app-header">
      <div className="main-header-container container-fluid">
        <div className="header-content-left">
          <div className="header-element">
            <div className="horizontal-logo">
              <a href="/dashboards" className="header-logo">
                <img src="assets/images/logo.png" alt="logo" className="desktop-logo" />
                <img src="assets/images/logo.png" alt="logo" className="toggle-logo" />
                <img src="assets/images/logo.png" alt="logo" className="desktop-dark" />
                <img src="assets/images/logo.png" alt="logo" className="toggle-dark" />
                <img src="assets/images/logo.png" alt="logo" className="desktop-white" />
                <img src="assets/images/logo.png" alt="logo" className="toggle-white" />
              </a>
            </div>
          </div>
          <div className="header-element">
            <a
              aria-label="Hide Sidebar"
              className="sidemenu-toggle header-link animated-arrow hor-toggle horizontal-navtoggle"
              href="javascript:void(0);"
            >
              <span />
            </a>
          </div>
        </div>

        <div className="header-content-right">
          <div className="header-element notifications-dropdown">
            <a href="/notification" className="header-link dropdown-toggle">
              <i className="bx bx-bell header-link-icon" />
              <span className="badge bg-secondary rounded-pill header-icon-badge pulse pulse-secondary">
                0
              </span>
            </a>
          </div>

          <div className="header-element">
            <a
              href="javascript:void(0);"
              className="header-link dropdown-toggle"
              id="mainHeaderProfile"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div className="d-flex align-items-center">
                <div className="me-sm-2 me-0">
                  <img
                    src="https://img.icons8.com/?size=80&id=21441&format=png"
                    alt="img"
                    width={32}
                    height={32}
                    className="rounded-circle"
                  />
                </div>
                <div className="d-sm-block d-none">
                  <p className="fw-semibold mb-0 lh-1">{user?.displayName || "Guest"}</p>
                  <span className="op-7 fw-normal text-success d-block fs-11">
                    {user ? "Active" : "Offline"}
                  </span>
                </div>
              </div>
            </a>

            <ul
              className="main-header-dropdown dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end"
              aria-labelledby="mainHeaderProfile"
            >
              <li>
                <a className="dropdown-item d-flex" href="/profile">
                  <i className="ti ti-user-circle fs-18 me-2 op-7" />
                  Profile
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex border-block-end" href="javascript:void(0);">
                  <i className="ti ti-wallet fs-18 me-2 op-7" />
                  Bal: {balance !== null ? `$${balance.toFixed(2)}` : "Loading..."}
                </a>
              </li>
              {/* <li>
                <a className="dropdown-item d-flex" href="/notification">
                  <i className="ti ti-bell fs-18 me-2 op-7" />
                  Notification
                </a>
              </li>
              <li>
                <a className="dropdown-item d-flex" href="/support">
                  <i className="ti ti-headset fs-18 me-2 op-7" />
                  Support
                </a>
              </li> */}
              <li>
                <button className="dropdown-item d-flex" onClick={handleLogout}>
                  <i className="ti ti-logout fs-18 me-2 op-7" />
                  Log Out
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
